import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src431700410/src/src/templates/markdown-page.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Metadata = makeShortcode("Metadata");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>
  Registry Operator Terms and Conditions Applicable to all .CA Registrations
    </h2>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  The Following clauses are required by CIRA (Canadian Internet Registration
  Authority) to be in the Agreement.&nbsp; For the purposes of the following
  clauses, you are referred to as the “Registrant” and <Metadata name="title" mdxType="Metadata" />{' '}
  as the “Registrar”.&nbsp; You agree to all of the following clauses:
    </p>
    <p>
  <strong>1.</strong> CIRA may, at its option, extend any period for the
  registration of a Domain Name at no charge to the Registrar or the Registrant
  for such further period of time as CIRA may determine, in its sole discretion;
    </p>
    <p>
  <strong>2.</strong> The Registrant agrees that CIRA shall not be liable to the
  Registrant for any loss, damage or expense arising out of CIRA’s failure or
  refusal to register a Domain Name, CIRA’s failure or refusal to renew a Domain
  Name Registration, CIRA’s registration of a Domain Name, CIRA’s failure or
  refusal to renew a Domain Name Registration, CIRA’s renewal of a Domain Name
  Registration, CIRA’s failure or refusal to transfer a Domain Name
  Registration, CIRA’s transfer of a Domain Name Registration, CIRA’s failure or
  refusal to maintain or modify a Domain Name Registration, CIRA’s maintenance
  of a Domain Name Registration, CIRA’s modification of a Domain Name
  Registration, CIRA’s failure to cancel a Domain Name Registration or CIRA’s
  cancellation of a Domain Name Registration from the Registry;{' '}
    </p>
    <p>
  <strong>3.</strong> In no event shall the Registrant pursue any Claim against
  CIRA, and in no event shall CIRA be liable for any direct, indirect, special,
  punitive, exemplary or consequential damages including but not limited to
  damages resulting from loss of use, lost profits, lost business revenue or
  third party damages or arising from any breach by the Registrar of its
  obligations under any agreement between the Registrar and a Registrant or the
  Registrar Agreement between CIRA and the Registrar;
    </p>
    <p>
  <strong>4.</strong> Registration of the Registrant’s selected Domain Name in
  its first application to CIRA shall not be effective until the Registrant has
  entered into and agreed to be bound by CIRA’s Registrant Agreement;{' '}
    </p>
    <p>
  <strong>5.</strong> The Registrar shall immediately give notice to the
  Registrant in the event that the Registrar is no longer a CIRA certified
  registrar, has had its certification as a CIRA certified Registrar suspended
  or terminated or the Registrar Agreement between CIRA and the Registrar is
  terminated or expires. CIRA may post notice of such suspension, termination or
  expiry on its website and may, if CIRA deems appropriate, give notice to the
  Registrant thereof;
    </p>
    <p>
  <strong>6.</strong> In the event that the Registrar is no longer a CIRA
  certified registrar, has had its certification as a CIRA certified registrar
  suspended or terminated or in the event the Registrar Agreement between CIRA
  and the Registrar is terminated or expires, each Registrant shall be
  responsible for changing its registrar of record to a new CIRA certified
  registrar within 30 days of the earlier notice thereof being given to the
  Registrant by (i) the Registrar or (ii) CIRA in accordance with CIRA’s then
  current Registration Rules; provided, however, that if any of the Registrant’s
  Domain Name Registration(s) is scheduled to expire within 30 days of the
  giving of such notice, then the Registrant shall have 30 days from the
  anniversary date of the registration(s), to register with a new CIRA certified
  registrar and to renew such Domain Name Registration(s) in accordance with the
  Registration Rules;
    </p>
    <p>
  <strong>7.</strong> The Registrant acknowledges and agrees that, should there
  be insufficient funds prepaid by the Registrar in the CIRA Deposit Account to
  be applied in payment of any Fees, CIRA may in its sole discretion stop
  accepting applications for Domain Name Registrations from the Registrar, stop
  effecting registrations of Domain Names and transfers, renewals, modifications
  and cancellations of Domain Name Registrations requested by the Registrar and
  stop performing other billable transactions requested by the Registrar not
  paid in full and CIRA may terminate the Registrar Agreement between CIRA and
  the Registrar;
    </p>
    <p>
  <strong>8.</strong> The Registrant shall not, directly or indirectly, through
  registration or use of its Domain Name or otherwise:
    </p>
    <blockquote>
  <p>
    8.1 violate or contribute to the violation of the intellectual property
    rights or other rights of any other Person;{' '}
  </p>
  <p>8.2 defame or contribute to the defamation of any other Person; or </p>
  <p>
    8.3 unlawfully discriminate or contribute to the unlawful discrimination of
    any other Person;
  </p>
    </blockquote>
    <p>
  <strong>9.</strong> The Registrant agrees that CIRA shall not be responsible
  for the use of any Domain Name in the Registry and that CIRA shall not be
  responsible in any way whatsoever for any conflict or dispute with or any
  actual or threatened Claim against a Registrar or a Registrant, including one
  relating to a registered or unregistered trade-mark, a corporate, business or
  other trade-name, rights relating to a name or other identifying indicium of
  an individual or any other intellectual property rights of a third party or
  relating to the defamation of or unlawful discrimination with respect to any
  other Person;
    </p>
    <p>
  <strong>10.</strong> CIRA shall have the right, at any time and from time to
  time, acting reasonably, to amend the Registrar Agreement between CIRA and the
  Registrar, including without limitation, the Certification and
  Re-certification Requirements, the Registration Rules, the Fees and the other
  Rules and Procedures and to adopt new Rules and Procedures not yet in
  effect.&nbsp; Any such amendment will be binding and effective on the
  Registrar 30 days after CIRA gives notice of such amendment by email to the
  Registrar.&nbsp; The Registrar and the Registrant agree to promptly amend the
  agreement between the Registrar and the Registrant to reflect any amendments
  to Section 4.2 of the Registrar Agreement between CIRA and the Registrar;
  and{' '}
    </p>
    <p>
  <strong>11.</strong> The Registrant acknowledges and agrees that registration
  of a Domain Name does not create any proprietary right for any Registrant, the
  Registrar or any other Person in the name used as a Domain Name or the Domain
  Name Registration and that the entry of a Domain Name in the Registry or in
  the “WHOIS” look up system of the Registry shall not be construed as evidence
  or ownership of the Domain Name registered as a Domain Name.&nbsp; The
  Registrant shall not in any way transfer or purport to transfer a proprietary
  right in any Domain Name Registration, or grant or purport to grant as
  security or in any other manner encumber or purport to encumber a Domain Name
  Registration.{' '}
    </p>
    <p>
  <strong>12.</strong> You agree that, after the expiration date of a .CA domain
  name registration and before it is renewed, deleted, or transferred, we may
  suspend the domain name causing the domain name to cease to resolve. The
  domain name's name server settings will not be modified as a result of the
  suspension.{' '}
    </p>
    <p>
  <strong>13.</strong> By purchasing a .CA domain, you are agreeing to the
  Canadian Internet Registration Authority (CIRA) Registrant Agreement listed
  below.
    </p>
    <h2>CIRA REGISTRANT INFORMATION</h2>{' '}
    <p align="center">
  <b>
    Registrant Agreement
    <br />
    Version 2.0, October 12, 2010
  </b>
    </p>{' '}
    <p>
  This agreement (the “Agreement”) is between you (the “<b>Registrant</b>”) and
  the Canadian Internet Registration Authority (“<b>CIRA</b>”).
    </p>
    <p>
  In consideration of the registration by CIRA of the Domain Name applied for by
  the Registrant in the name of the Registrant, and other good and valuable
  consideration, the receipt and adequacy of which are hereby acknowledged, CIRA
  and the Registrant agree as follows:
    </p>
    <p align="center">
  <b>
    ARTICLE 1<br />
    INTERPRETATION
  </b>
    </p>
    <p>
  <b>1.1 Application.</b> This Agreement between the Registrant and CIRA applies
  to all Domain Names registered by CIRA for the Registrant.
    </p>
    <p>
  <b>1.2 Definitions.</b> In this Agreement:
    </p>
    <p className="indented">
  “<b>Administrative Contact</b>” means the person identified in the
  Registration Information as the Administrative Contact for the Registrant’s
  Domain Name Registration(s);
    </p>
    <p className="indented">
  “<b>Affiliate</b>” means, with respect to either party, any entity that
  controls, is controlled by, or is under common control with, such party. For
  purposes of the foregoing, “control” means, with respect to: (a) a
  corporation, the ownership, directly or indirectly, of fifty percent (50%) or
  more of the voting power to elect directors thereof; and (b) any other entity,
  fifty percent (50%) or more ownership interest in said entity;
    </p>
    <p className="indented">“<b>Applicable Laws</b>” means all
international, federal, provincial and local laws and regulations and other
laws of applicable governmental authorities;</p><p>
    </p><p className="indented">“<b>Domain Name</b>” means a .ca domain name
or sub-domain name;</p>
    <p className="indented">
  “<b>Domain Name Registration</b>” means the registration by CIRA of a Domain
  Name in the Registry, in the name of the Registrant, pursuant to this
  Agreement;
    </p>
    <p className="indented">
  “<b>Fees</b>” means the fees payable to CIRA in connection with this
  Agreement, including an application for a Domain Name and/or any renewal,
  transfer, and any other fees payable in connection with a Domain Name
  Registration;
    </p>{' '}
    <p className="indented">
  “<b>Member</b>” or “<b>Membership</b>” has the meaning specified in CIRA’s
  <i>Amended and Restated By-Law No.1</i>, which is located on CIRA’s website at:{' '}
  <a href="http://www.cira.ca/assets/Documents/Legal/Other/bylaw1.pdf" target="_blank">
    www.cira.ca/assets/Documents/Legal/Other/bylaw1.pdf
  </a>;
    </p>{' '}
    <p className="indented">
  “<b>Person</b>” means a natural person, partnership, limited partnership,
  limited liability partnership, corporation, limited liability corporation,
  unlimited liability company, joint stock company, trust, unincorporated
  association, joint venture or other entity or governmental entity;
    </p>
    <p className="indented">
  “<b>Registrant</b>” means a Person who is listed in the Registry as the
  registrant of a Domain Name;
    </p>{' '}
    <p className="indented">
  “<b>Registrar of Record</b>” means the Registrar listed in the Registry as the
  Registrar of a specific Domain Name Registration;
    </p>{' '}
    <p className="indented">
  “<b>Registrars</b>” mean the persons from time to time certified by CIRA to
  offer Domain Name Registration services within the .ca Internet Domain Name
  system;
    </p>
    <p className="indented">
  “<b>Registration Date</b>” means the date a Domain Name has been activated
  within the Registry;
    </p>{' '}
    <p className="indented">
  “<b>Registration Information</b>” means all information which the Registry PRP
  require the Registrant to submit to CIRA or the Registrar of Record to obtain
  a Domain Name Registration, or to process any Transaction Request;
    </p>{' '}
    <p className="indented">
  “<b>Registry</b>” means the .ca Internet Domain Name registry operated by
  CIRA;
    </p>{' '}
    <p className="indented">
  “<b>Registry PRP</b>” means the CIRA policies, rules, and procedures relating
  to Registrants, Registrars, and Domain Name Registrations as may be amended or
  adopted by CIRA from time to time, which are located on CIRA’s website at:{' '}
  <a href="http://www.cira.ca/en/PRP.html" target="_blank">
    www.cira.ca/en/PRP.html
  </a>
  ; and
    </p>{' '}
    <p className="indented">
  “<b>Transaction Requests</b>” means all requests or transactions with respect
  to a Domain Name Registration, including those to renew, transfer, modify, or
  delete a Domain Name Registration.
    </p>{' '}
    <p align="center">
  <b>
    ARTICLE 2<br />
    AGREEMENT, REGISTRY PRP, AND AMENDMENTS BY CIRA
  </b>
    </p>
    <p>
  <b>2.1 Acceptance of Agreement and Registry PRP.</b> This Agreement sets forth
  the terms and conditions of the registration of Domain Names by the Registrant
  with CIRA. The Registrant acknowledges that it has read, understood, and
  agrees to be bound by all the terms and conditions of this Agreement, and the
  Registry PRP, which CIRA may establish and amend from time to time. The
  Registry PRP are located on CIRA’s website at{' '}
  <a href="http://www.cira.ca/en/PRP.html" target="_blank">
    www.cira.ca/en/PRP.html
  </a>
  . The acceptance of the Registrant Agreement and Registry PRP by the
  Registrant will apply to the current registration request as well as all other
  further registration requests which the Registrant may make thereafter with
  the same Registrar.
    </p>{' '}
    <p>
  <b>2.2 Amendment of Agreement by CIRA.</b> CIRA shall have the right, at any
  time and from time to time, to amend any or all of the terms and conditions of
  this Agreement. CIRA shall use commercially reasonable efforts to notify the
  Registrant of material amendments to this Agreement by email in accordance
  with Section 10.1. However, any amendment to this Agreement will be binding
  and effective upon 30 days after the posting of such amendment on CIRA’s
  website.
    </p>{' '}
    <p>
  <b>2.3 Amendment and/or Establishment of new Registry PRP by CIRA.</b> CIRA
  shall have the right, at any time and from time to time, to amend any or all
  of the Registry PRP and/or establish new Registry PRP. Any such amendment to
  the Registry PRP or new Registry PRP will be binding and effective upon the
  posting of such amendment or new Registry PRP on CIRA’s website.
    </p>
    <p>
  <b>2.4 Obligation to Review; Disagreement.</b> The Registrant agrees to
  periodically review CIRA’s website, and specifically this Agreement and the
  Registry PRP available on CIRA’s website, to be aware of any amendments to the
  Agreement, Registry PRP and/or any new Registry PRP. If the Registrant does
  not agree with any amendments to the Agreement, the Registry PRP and/or any
  new Registry PRP, then the Registrant may terminate this Agreement in
  accordance with Section 7.10. By continuing to maintain Domain Name
  Registrations in the Registry, the Registrant has agreed to be bound by any
  amendments to the Agreement, the Registry PRP and/or the establishment of any
  new Registry PRP after they become effective.
    </p>
    <p align="center">
  <b>
    ARTICLE 3<br />
    DOMAIN NAMES PROVISIONS
  </b>
    </p>
    <p>
  <b>3.1 Registrations of Domain Names.</b>
    </p>
    <p className="indented">
  (a) <b>Applications.</b> The Registrant acknowledges and agrees that
  applications for the registration of a Domain Name shall be made to CIRA only
  by the Registrar of Record, on behalf of the Registrant, in accordance with
  this Agreement and the Registry PRP.
    </p>
    <p className="indented">
  (b) <b>Processing of Applications.</b> CIRA shall process complete
  applications for the registration of a Domain Name. CIRA, in its sole
  discretion, shall have the right to approve or reject any application for the
  registration of a Domain Name and/or agree or refuse to register any Domain
  Name for any reason whatsoever with no liability of CIRA whatsoever to the
  Registrant, the Registrar of Record or any other person. CIRA will give notice
  to the Registrar of Record upon the approval or rejection of an application.
    </p>
    <p>
  <b>3.2 No Proprietary Right.</b> The Registrant acknowledges and agrees that a
  Domain Name is not property and that a Domain Name Registration does not
  create any proprietary right for the Registrant, the Registrar of Record or
  any other person in any name used as a domain name or in any Domain Name
  Registration. The entry of a domain name in the Registry and/or in the “WHOIS”
  database shall not be construed as evidence of ownership of any Domain Name
  Registration. The Registrant shall not in any way transfer or purport to
  transfer a proprietary right in any Domain Name Registration or grant or
  purport to grant as security or in any other manner encumber or purport to
  encumber any Domain Name Registration.
    </p>
    <p>
  <b>
    3.3 Renewals, Transfers, Modifications, Deletions and Other Transactions.
  </b>{' '}
  The Registrant acknowledges and agrees that a renewal, transfer, modification
  or deletion of, and any other request or transaction with respect to, a Domain
  Name Registration shall be made in accordance with this Agreement and the
  Registry PRP. CIRA will notify the Registrar of Record of any renewal,
  transfer, modification, deletion or other transaction regarding a Domain Name
  Registration.
    </p>
    <p>
  <b>3.4 Right of CIRA to Verify Information and Compliance.</b> CIRA is
  entitled at any time and from time to time during the Term (as defined in
  Section 7.1) to verify: (a) the truth, accuracy and completeness of any
  information provided by the Registrant to CIRA, whether directly, through any
  of the Registrars of Record or otherwise; and (b) the compliance by the
  Registrant with the provisions of the Agreement and the Registry PRP. The
  Registrant shall fully and promptly cooperate with CIRA in connection with
  such verification and shall give to CIRA, either directly or through the
  Registrar of Record such assistance, access to and copies of, such information
  and documents as CIRA may reasonably require to complete such verification.
  CIRA and the Registrant shall each be responsible for their own expenses
  incurred in connection with such verification.
    </p>
    <p><b>3.5	Administrative Contacts.</b></p>   
    <p className="indented">(a) 	<b>Agent for the Registrant.</b> The
Registrant acknowledges and agrees that the Administrative Contact is hereby
irrevocably authorized by the Registrant to: 1. act as the Registrant’s
agent in connection with the Registrant’s Domain Name Registrations; 2.
be CIRA’s contact for the Registrant and the Domain Name
Registration(s); and 3. is recognized by CIRA and hereby irrevocably
authorized by the Registrant to take any and all actions in connection with
the Domain Name Registration(s) including, without limitation, renewing,
transferring, modifying, or deleting it.  Notwithstanding the foregoing, in
the event of any dispute between the Registrant and the Registrant’s
Administrative Contact, the Registrant shall prevail. 
    </p><p className="indented">(b)		<b>Registrant and Administrative Contact Email
Addresses.</b>  The Registrant acknowledges and agrees that CIRA notices to
the Registrant will be sent by email only, as set forth in Section 10.1
(Notices). It is solely the responsibility of the Registrant to ensure that
the email addresses of the Registrant and its Administrative Contact are at
all times functional and accurate and to make arrangements with its
Administrative Contact to receive any notices that are sent by CIRA only to
the Registrant’s Administrative Contact.  If CIRA can show that a notice
was sent to either the Registrant or the Registrant’s Administrative
Contact email addresses, CIRA shall not be liable to the Registrant or any
third party for damages arising from a failure to receive notice from CIRA.
    </p><p><b>3.6 	Registrars.</b></p>
    <p className="indented">(a)		<b>Changes of Registrar.</b> 
    </p><p className="doubleindented">(1) 	<b>Time Period.</b>  The Registrant may change
the Registrar of Record with respect to a Domain Name Registration at any time
once 60 days has elapsed from the date of registration of the Domain Name.</p>  
    <p className="doubleindented">(2) 	<b>Replacement of Registrar.</b>  In the event
that the Registrar of Record  is no longer a Registrar for any reason, has had
its certification as a Registrar suspended, revoked or terminated, and/or the
Registrar Agreement between CIRA and the Registrar of Record is terminated or
expires, the Registrant shall be responsible for changing such  Registrar of
Record to a new Registrar.  Such change must occur within 30 days of notice
being given to the Registrant, or such other period of time specified by CIRA.
    </p><p className="doubleindented">(3) 	<b>Agreement and Registry PRP.</b>  Any change
of the Registrar of Record must be done in accordance with this Agreement and
the Registry PRP.
    </p><p className="indented">(b)	<b>Registrar as Agent.</b>	The Registrant
acknowledges and agrees that the Registrar of Record is hereby also
irrevocably authorized to act as the Registrant’s agent in connection
with Domain Name Registrations.  Accordingly, any communication and/or
instructions to or from the Registrar of Record will be taken as being to or
from the Registrant.  Without limiting the generality of the foregoing, the
Registrant acknowledges and agrees that the Registrar of Record may cancel the
Registrant’s Domain Name Registration within 5 days from the
registration of the Domain Name at their discretion and without the
Registrant’s consent.</p>
    <p className="indented">
  (c) <b>Registrar Obligations.</b> The Registrant acknowledges that the
  Registrar of Record has a number of obligations to CIRA, and should the
  Registrar fail to comply with such obligations, CIRA may require the
  Registrant to change such Registrar of Record to a new Registrar.
    </p>{' '}
    <p>
  <b>3.7 Membership.</b> The Registrant acknowledges and agrees that if the
  Registrant becomes a Member of CIRA, the Registrant agrees to abide by the
  terms of CIRA Membership, as set out in CIRA’s{' '}
  <i>Amended and Restated By-law No.1</i>, <i>Policy on Membership</i> and the
  Registry PRP, which are located on CIRA’s website at{' '}
  <a href="http://www.cira.ca/assets/Documents/Legal/Other/bylaw1.pdf" target="_blank">
    www.cira.ca/assets/Documents/Legal/Other/bylaw1.pdf
  </a>
  ,{' '}
  <a href="http://www.cira.ca/assets/Documents/Legal/Membership/membership.pdf" target="_blank">
    www.cira.ca/assets/Documents/Legal/Membership/membership.pdf
  </a>
  , and{' '}
  <a href="http://www.cira.ca/en/PRP.html" target="_blank">
    www.cira.ca/en/PRP.html respectively
  </a>
  .
    </p>{' '}
    <p align="center">
  <b>
    ARTICLE 4<br />
    CERTAIN REGISTRANT OBLIGATIONS
  </b>
    </p>
    <p>
  <b>4.1 Certain Registrant Obligations.</b> Throughout the Term of this
  Agreement, the Registrant shall comply with and abide by all provisions of
  this Agreement and the Registry PRP. Furthermore, the Registrant shall, in
  accordance with this Agreement and the Registry PRP:
    </p>
    <p className="indented">
  (a) submit Registration Information to CIRA upon request, and ensure at all
  times that the Registration Information is true, complete and accurate;
    </p>
    <p className="indented">
  (b) promptly give notice to the Registrar of Record (for communication to
  CIRA), of any change to any Registration Information;
    </p>
    <p className="indented">(c) comply with and observe all Applicable Laws;</p>
    <p className="indented">
  (d) immediately give notice to CIRA of any pending or threatened claim,
  demand, action, cause of action, proceeding, lawsuit, investigation or
  application (collectively a “<b>Claim</b>”) in relation to any Domain Name
  Registration (or any judicial requests or orders to produce documents or
  information obtained from or supplied to the Registry) that became known to
  the Registrant;
    </p>
    <p className="indented">
  (e) not engage in any direct or indirect activity which, in CIRA’s reasonable
  opinion, is designed to bring, or may bring, the Registry into disrepute, is
  designed to interfere, or may interfere, with CIRA’s operations or is designed
  to expose, or may expose, CIRA to prosecution or to legal action by the
  Registrant or a third party;
    </p>
    <p className="indented">(f) act in good faith towards CIRA;</p>
    <p className="indented">
  (g) not allow any third party to use or operate any Domain Name Registration
  registered in the name of the Registrant and not register any Domain Name as
  agent for, or on behalf of, any third party in any manner whatsoever,
  including without limiting the generality of the foregoing, for the purposes
  of lending, leasing, licensing or otherwise granting rights in such Domain
  Name Registration to any third party for monetary or non-monetary
  consideration, unless such third party: (i) otherwise qualifies under the
  applicable Registry PRP including without limitation CIRA’s{' '}
  <i>Canadian Presence for Registrants</i> which is located on CIRA’s website at{' '}
  <a href="http://www.cira.ca/assets/Documents/Legal/Registrants/CPR.pdf" target="_blank">
    www.cira.ca/assets/Documents/Legal/Registrants/CPR.pdf
  </a>
  ; or (ii) is an Affiliate of the Registrant. For this purpose, “
  <b>third party</b>” means any Person other than CIRA and the Registrant.
    </p>
    <p className="indented">
  (h) be wholly responsible for the use and operation of any third, fourth, or
  further sub-level domain to any second level Domain Name Registration in the
  Registrant’s name and the Registrant shall ensure that the use and operation
  of any such sublevel domain is conducted in compliance with this Agreement and
  the Registry PRP;
    </p>
    <p className="indented">
  (i) not use any trade-mark, trade-name or symbol of CIRA or any trade-mark,
  trade-name or symbol likely to be confused therewith; and
    </p>
    <p className="indented">
  (j) be wholly responsible for taking, or ensuring that the Registrar of Record
  deletes a Domain Name Registration during the Auto-Renew Grace Period, as such
  term is defined in the <i>General Registration Rules</i>, if the Registrant
  does not wish that the Domain Name Registration be renewed.
    </p>{' '}
    <p>
  <b>4.2 No Conflict.</b> The Registrant shall not enter into any agreement with
  any Registrar or any other person that is inconsistent with, or in any way,
  modifies, affects, overrides, limits, contradicts or cancels the terms and
  conditions of this Agreement and/or the Registry PRP. To the extent that the
  provisions of any such agreement conflict or are inconsistent with the
  provisions of this Agreement and/or the Registry PRP, the Registrant hereby
  agrees that the provisions of this Agreement and Registry PRP shall prevail
  and be binding on the Registrant for the benefit of CIRA.
    </p>
    <p align="center">
  <b>
    ARTICLE 5<br />
    REGISTRATION INFORMATION
  </b>
    </p>
    <p>
  <b>5.1 Consent to Use of Registration Information.</b> The Registrant consents
  to the collection, use, storage and disclosure of Registration Information,
  including any personal information of the Registrant, as set out in CIRA’s{' '}
  <i>Privacy Policy</i>, which is located on CIRA’s website at:{' '}
  <a href="http://www.cira.ca/assets/Documents/Legal/Registrants/privacy.pdf" target="_blank">
    www.cira.ca/assets/Documents/Legal/Registrants/privacy.pdf
  </a>
  .
    </p>
    <p>
  <b>5.2 Disclosure Procedure.</b> For any Registration Information which is not
  made available in the WHOIS database, the Registrant acknowledges and agrees
  that: (a) such information will be maintained in the CIRA Registry and may be
  used and disclosed by CIRA as permitted herein and/or in the Registry PRP; and
  (b) CIRA shall have no liability for any claim, damage, loss or expense
  arising as a result of the disclosure of Registrant Information as permitted
  herein and/or the Registry PRP.
    </p>{' '}
    <p>
  <b>5.3 Third Party Correspondence.</b> The Registrant acknowledges and agrees
  that CIRA may forward to the Registrant any correspondence from third parties
  and may exercise its discretion to refuse to forward such correspondence. The
  Registrant agrees that CIRA shall have no liability for any claim, damage,
  loss or expense arising as a result of CIRA reviewing, sending, delaying or
  failing to review or send any such correspondence to the Registrant. The
  Registrant further acknowledges and agrees that CIRA has no control over the
  content of information that may be sent to the Registrant via CIRA and that
  CIRA shall have no liability for any claim, damage, loss or expense arising as
  a result of any such content.
    </p>
    <p>
  <b>5.4 WHOIS.</b> The Registrant acknowledges and agrees that CIRA has no
  control over how any person uses the information disclosed by CIRA through the
  WHOIS database, whether or not the information is subject to domestic or
  foreign privacy laws.
    </p>
    <p align="center">
  <b>
    ARTICLE 6<br />
    REGISTRANT REPRESENTATIONS AND WARRANTIES
  </b>
    </p>{' '}
    <p>
  <b>6.1 Representations and Warranties.</b> The Registrant covenants,
  represents and warrants to CIRA as follows:
    </p>
    <p className="indented">
  (a) <b>Authorization.</b> The Registrant has the power, authority and capacity
  to enter into this Agreement and all other documents and instruments
  contemplated by this Agreement and to carry out its obligations under this
  Agreement and such other documents and instruments.
    </p>
    <p className="indented">
  (b) <b>Registration Information.</b> During the Term of this Agreement, all
  Registration Information is and at all times shall be true, complete and
  accurate and not misleading.
    </p>
    <p className="indented">
  (c) <b>No Infringement.</b> During the Term of this Agreement, neither the
  registration of any Domain Name nor the manner in which the Registrant intends
  to use or uses such Domain Name will directly or indirectly infringe or
  otherwise violate the copyright, trade-mark, patent or other intellectual
  property or other rights of any person or defame any person or unlawfully
  discriminate against any person or breach any Applicable Laws.
    </p>
    <p className="indented">
  (d) <b>Qualification.</b> During the Term of this Agreement, the Registrant
  meets and shall continue to meet all the requirements of this Agreement and
  the Registry PRP to: (a) be a Registrant, (b) apply for the registration of a
  Domain Name Registration, and (c) hold and maintain a Domain Name
  Registration, including without limitation CIRA’s
  <i>Canadian Presence Requirements for Registrants</i>, which is located on CIRA’s
  website at: <a href="http://www.cira.ca/assets/Documents/Legal/Registrants/CPR.pdf" target="_blank">
    www.cira.ca/assets/Documents/Legal/Registrants/CPR.pdf
  </a>.
    </p>
    <p>
  <b>6.2 Survival.</b> The Registrant acknowledges and agrees that the
  limitations on warranties, conditions and liabilities, and the representations
  and warranties of the Registrant contained herein shall forever survive the
  expiry or termination of this Agreement or any suspension or deletion of any
  Domain Name Registration.{' '}
    </p>
    <p align="center">
  <b>
    ARTICLE 7<br />
    TERM; RIGHTS AND REMEDIES OF CIRA
  </b>
    </p>{' '}
    <p>
  <b>7.1 Term.</b> The term of this Agreement (the “<b>Term</b>”) shall commence
  effective upon the date that the Registrant enters into this Agreement with
  CIRA and shall continue in force until terminated as set out herein.
    </p>{' '}
    <p>
  <b>7.2 Restrictions on Domain Name Registrations.</b> CIRA may, in accordance
  with this Agreement, the Registry PRP or, in its sole discretion and at its
  sole option, restrict the Registrant’s ability to renew, transfer, modify, or
  delete any or all of the Registrant’s Domain Name Registrations.
    </p>{' '}
    <p>
  <b>7.3 Suspension and/or Deletion of Domain Name Registrations.</b>
  CIRA may, in its sole discretion and at its sole option, upon notice to the Registrant
  suspend and/or delete a Domain Name Registration within 30 days of the registration
  of the Domain Name for any reason whatsoever. CIRA may also, in its sole discretion
  and at its sole option, upon notice to the Registrant suspend and/or delete a Domain
  Name Registration in the event that:
    </p>
    <p className="indented">
  (a) the Registration Information concerning such Domain Name Registration
  contains false, misleading, incomplete, and/or inaccurate information;
    </p>
    <p className="indented">
  (b) the Registrar of Record fails to pay to CIRA when due any Fees payable by
  the Registrar of Record to CIRA with respect to a Domain Name Registration for
  any reason whatsoever;
    </p>
    <p className="indented">
  (c) the Registrant breaches any term of this Agreement or any of the Registry
  PRP;
    </p>
    <p className="indented">
  (d) the Registrant at any time fails to meet all of the requirements of this
  Agreement and/or the Registry PRP to: (a) be a Registrant, (b) apply for the
  registration of a Domain Name Registration, and/or (c) hold and maintain a
  Domain Name Registration, including without limitation CIRA’s{' '}
  <i>Canadian Presence Requirements for Registrants</i>, which is located on
  CIRA’s website at:{' '}
  <a href="http://www.cira.ca/assets/Documents/Legal/Registrants/CPR.pdf" target="_blank">
    www.cira.ca/assets/Documents/Legal/Registrants/CPR.pdf
  </a>
  ;
    </p>
    <p className="indented">
  (e) the Registrant engages in any direct or indirect activity which in CIRA’s
  reasonable opinion: (1) brings, or may bring, the Registry into disrepute; (2)
  interferes, or may interfere, with the Registry and/or CIRA’s operations;
  and/or (3) exposes, or may expose, CIRA to prosecution or to legal action by
  the Registrant or a third party;
    </p>
    <p className="indented">
  (f) maintaining the Domain Name Registration would put CIRA in conflict with
  requirements of Applicable Laws, or any applicable federal, provincial or
  territorial human rights legislation or the <i>Criminal Code</i> (Canada), or
  the terms of an order, ruling, decision or judgment of a court, tribunal,
  board, administrative body, commission or arbitrator;
    </p>
    <p className="indented">
  (g) the deletion, transfer or suspension of a Domain Name Registration is
  required by an order or decision under CIRA’s Domain Name Dispute Resolution
  Policy or an order, ruling, decision or judgment of a court, tribunal, board,
  administrative body, commission or arbitrator; or
    </p>
    <p className="indented">
  (h) the designation by the government of Canada of CIRA to manage, operate and
  control the Registry is terminated or CIRA is no longer recognized at the
  international level as having the exclusive authority to operate the Registry.
    </p>
    <p>
  <b>7.4 Suspension and/or Deletion by CIRA.</b> In addition to CIRA’s other
  rights and remedies herein, CIRA may at its sole discretion and at its sole
  option suspend and/or delete any Domain Name Registration that it deems
  necessary to (1) protect the integrity and stability of the registry; (2) to
  comply with any applicable laws, government rules or requirements, requests of
  law enforcement, or any dispute resolution process; (3) to avoid any
  liability, civil or criminal, on the part of CIRA, as well as its officers,
  directors, and employees; or (4) to correct mistakes made by CIRA or any
  Registrar in connection with a Domain Name Registration.
    </p>{' '}
    <p>
  <b>
    7.5 Suspension and Deletion for Failure to Confirm Registration Information.
  </b>{' '}
  CIRA may in its sole discretion and at its sole option immediately suspend a
  Domain Name Registration for failure by the Registrant to satisfactorily
  confirm the truth, accuracy and/or completeness of Registration Information
  upon CIRA’s request. During the period of suspension as prescribed by CIRA,
  the Registrant may at any time reactivate the suspended Domain Name
  Registration by satisfactorily confirming or correcting the Registration
  Information. If a Registrant fails to confirm the Registration Information in
  accordance with the Registry PRP within the period of suspension prescribed by
  CIRA, CIRA may, in its sole discretion, delete the Domain Name Registration.
    </p>
    <p>
  <b>7.6 Effect of Suspension.</b> During any period in which a Domain Name
  Registration has been suspended pursuant to the provisions of this Agreement
  or the Registry PRP:
    </p>
    <p className="indented">
  (a) the Domain Name Registration will not be included in the list of Domain
  Name Registrations transferred on a daily basis to the Registry’s primary
  domain name server and accordingly, an Internet user will not be able to send
  an email or access a web page which incorporates such Domain Name
  Registration;
    </p>
    <p className="indented">
  (b) no transactions or activities associated with the Domain Name Registration
  and/or information concerning the Domain Name Registration will be possible,
  including without limitation, renewals, transfers, deletions, modifications or
  other requests or transactions;
    </p>
    <p className="indented">
  (c) CIRA will continue to list such suspended Domain Name Registration in the
  WHOIS look up system of the Registry and the WHOIS look up system will
  indicate that the Domain Name Registration has been suspended;
    </p>
    <p className="indented">
  (d) CIRA may reactivate the suspended Domain Name Registration at any time in
  its sole discretion; and
    </p>
    <p className="indented">
  (e) CIRA may extend the period of suspension at any time for such period as
  CIRA may determine in its sole discretion.
    </p>
    <p>
  <b>7.7 Effect of Deletion of a Domain Name Registration.</b> Upon the deletion
  by CIRA of a Domain Name Registration for any reason pursuant to this
  Agreement:
    </p>
    <p className="indented">
  (a) the Registrant will no longer be entitled to the use of such Domain Name
  Registration and accordingly, an Internet user will not be able to send an
  email or access a web page which incorporates such Domain Name Registration;
    </p>
    <p className="indented">
  (b) the Domain Name Registration will be deleted from the Registry and will be
  available for registration in the name of another person;
    </p>
    <p className="indented">
  (c) CIRA will list the deleted Domain Name Registration as available in its
  WHOIS look up system; and
    </p>
    <p className="indented">
  (d) if the Registrant is a Member, the Registrant will cease being a Member
  forthwith after deletion of the Domain Name Registration, unless the
  Registrant has at least one other Domain Name Registration.
    </p>
    <p>
  <b>7.8 Prohibition on New Registrations.</b> CIRA, in its sole discretion,
  shall have the right to refuse any Registration Request from an Applicant if
  the Applicant previously had a Registrant Agreement terminated by CIRA.
    </p>
    <p>
  <b>7.9 Termination of Agreement by CIRA.</b> CIRA may, in its sole discretion
  and at its sole option, terminate this Agreement by giving notice thereof to
  the Registrant (such termination to be effective on the date specified by CIRA
  in the notice) in the event that:
    </p>
    <p className="indented">
  (a) the Registrant breaches any term of this Agreement or any of the Registry
  PRP, other than as set forth in Sections 7.8(b) through (g), and fails to cure
  that breach within 10 days of receipt of notice from CIRA;
    </p>
    <p className="indented">
  (b) the Registrant disrupts or abuses CIRA’s registry services as determined
  by CIRA in its sole discretion, acting reasonably;
    </p>
    <p className="indented">
  (c) all of the Domain Name Registrations registered in the name of the
  Registrant have been deleted or have expired;
    </p>
    <p className="indented">
  (d) the designation by the government of Canada of CIRA to manage, operate and
  control the Registry is terminated or CIRA is no longer recognized at the
  international level as having the exclusive authority to operate the Registry;
    </p>
    <p className="indented">
  (e) the Registrant files, or consents to the filing against it of, any
  petition for relief, reorganization or liquidation under any bankruptcy or
  insolvency law of any jurisdiction, or has any such petition filed against it
  that is not dismissed within 30 days thereafter;
    </p>
    <p className="indented">
  (f) the Registrant makes a general assignment for the benefit of its
  creditors, or consents to the appointment of a custodian, receiver, trustee or
  other officer with similar powers over a substantial portion of its assets, or
  has any proceeding seeking such an appointment filed against it;
    </p>
    <p className="indented">
  (g) an execution or any other process of any court shall become enforceable
  against the Registrant; and/or
    </p>
    <p className="indented">
  (h) the Registrant ceases to carry on business in the normal course, dissolves
  or is wound up, or ceases to exist as the Person listed in the Registry.
    </p>{' '}
    <p>
  <b>7.10 Termination by Registrant.</b> The Registrant shall be entitled
  (either directly or through the Registrar of Record) to terminate this
  Agreement at any time by giving 30 days notice to CIRA. The Registrant
  understands and agrees that there shall be no refund of any Fees in such
  event.
    </p>
    <p>
  <b>7.11 Effect of Termination of Agreement.</b> Upon termination of this
  Agreement for any reason: (a) all Domain Name Registrations in the name of the
  Registrant shall be immediately and automatically deleted and they shall be
  made available for any other person to register; (b) in the case of a
  Registrant who is a Member, the immediate and automatic termination of the
  Registrant’s Membership in CIRA; and (c) Sections 5.1, 6, 7.9, 8, 9 and 10 of
  this Agreement shall survive.
    </p>
    <p align="center">
  <b>
    ARTICLE 8<br />
    LIMITATIONS ON WARRANTIES, CONDITIONS, LIABILITY; INDEMNIFICATION
  </b>
    </p>
    <p><b>8.1	EXCLUSION OF REPRESENTATIONS, WARRANTIES AND CONDITIONS.</b>
THE REGISTRANT EXPRESSLY UNDERSTANDS AND AGREES THAT:</p>
    <p className="indented">ALL SERVICES PROVIDED BY CIRA, INCLUDING WITHOUT
LIMITATION, THE PROVISION OF DOMAIN NAME REGISTRATIONS
(“SERVICES”), ARE PROVIDED ON AN “AS IS” AND “AS
AVAILABLE” BASIS. CIRA MAKES NO REPRESENTATIONS, WARRANTIES OR
CONDITIONS OF ANY KIND, WHETHER ORAL OR WRITTEN, EXPRESS OR IMPLIED, STATUTORY
OR OTHERWISE REGARDING THE SERVICES, INCLUDING, WITHOUT LIMITATION, ANY
WARRANTY OR CONDITION OF MERCHANTABLE QUALITY OR FITNESS FOR A PARTICULAR
PURPOSE OR NON-INFRINGEMENT.</p><p>
    </p><p>WITHOUT LIMITING THE FOREGOING, CIRA MAKES NO WARRANTY:</p>
    <ul>
      <p></p><li>THAT THE REGISTRY WILL BE AVAILABLE AT ALL TIMES DURING THE TERM;<p></p>
        <p></p></li><li>THAT THE SERVICES WILL BE TIMELY, SECURE OR ERROR FREE;<p></p>
        <p></p></li><li>THAT THE SERVICES WILL BE FREE FROM BUGS OR VIRUSES;<p></p>
        <p></p></li><li>WITH RESPECT TO THE ACCESSIBILITY, COMPATIBILITY OR INTEROPERABILITY OF
THE REGISTRY OR THE SYSTEMS ACCESSED BY THE REGISTRAR(S) OF RECORD AND/OR THE
REGISTRANT; OR<p></p>
        <p></p></li><li>WITH RESPECT TO THE SECURITY OF THE REGISTRY OR ANY SYSTEMS ACCESSED BY
THE REGISTRAR(S) OF RECORD AND/OR THE REGISTRANT.<p></p>
      </li></ul>
    <p><b>8.2 	LIMITATION OF LIABILITY.</b>  NOTWITHSTANDING ANY PROVISION OF
THIS AGREEMENT TO THE CONTRARY, REGARDLESS OF THE FORM OR CAUSE OF ACTION
WHETHER IN CONTRACT OR TORT OR THE NUMBER OF CLAIMS, WHETHER OR NOT SUCH
DAMAGES ARE FORESEEABLE OR CIRA HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
DAMAGES, AND WHETHER IN RESPECT OF A BREACH OR DEFAULT IN THE NATURE OF A
BREACH OF CONDITION OR FUNDAMENTAL TERM OR A FUNDAMENTAL BREACH:
    </p><p className="indented">(A)	CIRA AND ITS DIRECTORS, OFFICERS, EMPLOYEES, AGENTS OR
REPRESENTATIVES SHALL NOT HAVE ANY LIABILITY TO THE REGISTRANT FOR ANY
ECONOMIC, CONSEQUENTIAL, INDIRECT, INCIDENTAL OR SPECIAL DAMAGES (INCLUDING,
BUT NOT LIMITED TO, ANY LOST REVENUES OR PROFITS) ARISING OUT OF OR RELATED TO
THIS AGREEMENT, AND</p>
    <p className="indented">(B) CIRA’S ENTIRE LIABILITY FOR ANY CLAIM ARISING
OUT OF OR RELATED TO THIS AGREEMENT (OTHER THAN LIABILITY FOR DEATH OR
PERSONAL INJURY CLAIMS) SHALL  BE LIMITED TO ACTUAL, DIRECT, PROVABLE DAMAGES
NOT TO EXCEED THE AMOUNT RECEIVED BY CIRA FROM THE  REGISTRAR OF RECORD FOR
THE DOMAIN NAME REGISTRATION THAT IS THE SUBJECT OF SUCH CLAIM.</p>
 
    <p>FOR GREATER CERTAINTY, AND WITHOUT LIMITING THE GENERALITY OF THE
FOREGOING, THIS EXCLUSION OF LIABILITY SHALL APPLY TO ANY COSTS, LOSSES OR
DAMAGES OF ANY KIND WHATSOEVER ARISING FROM OR RELATED TO ACCESS DELAYS OR
INTERRUPTIONS TO THE REGISTRY, CIRA’S WEBSITE, ANY PRODUCT, SERVICE OR
OPERATION (INCLUDING BUT NOT LIMITED TO E-MAIL AND VOIP) RELYING ON THE PROPER
FUNCTION OF THE .CA DOMAIN, THE REGISTRANT’S WEBSITE, OR THE DOMAIN NAME
REGISTRATION SYSTEM; ISSUES WITH THE DNS (“DOMAIN NAME SYSTEM”);
UNAUTHORIZED USE OR MISUSE OF THE REGISTRATION INFORMATION; OR CIRA’S
FAILURE OR REFUSAL TO REGISTER, RENEW, TRANSFER, MAINTAIN, MODIFY OR DELETE A
DOMAIN NAME REGISTRATION. THE REGISTRANT ALSO AGREES TO BE BOUND BY THE
LIMITATION OF LIABILITY CLAUSE IN THE CIRA DOMAIN NAME DISPUTE RESOLUTION
POLICY.</p>
    <p>
  <b>8.3 Indemnity.</b>
    </p>
    <p className="indented">
  (a) The Registrant agrees to defend, indemnify and save CIRA and its
  contractors, agents, employees, officers, directors, Members, affiliates and
  assigns harmless from and against any and all damages, liabilities,
  obligations, losses, claims, demands, actions, causes of action, lawsuits,
  penalties, costs and expenses (including, without limitation, reasonable legal
  and other related costs) arising out of or in any way connected with the
  Registrant’s use of the Services, including without limitation the
  Registrant’s use of any Domain Name Registration, the Registrant’s violation
  of the Registrant Agreement or Registry PRP, or the Registrant’s violation of
  any rights of another person.
    </p>
    <p className="indented">
  (b) If a Claim is made, or CIRA believes a Claim is likely, CIRA may seek
  written assurances from the Registrant concerning their obligation to
  indemnify CIRA. The Registrant acknowledges and agrees that its failure to
  provide those assurances may be considered by CIRA to be a material breach of
  this Agreement.
    </p>
    <p className="indented">
  (c) CIRA shall have the right to participate in any defence by the Registrant
  of a third-party claim, with counsel of CIRA’s choice at CIRA’s own expense.
  CIRA shall reasonably cooperate in the defence at the Registrant’s request and
  expense. The Registrant must receive CIRA’s prior written consent regarding
  any related settlement of a Claim.
    </p>
    <p align="center">
  <b>
    ARTICLE 9<br />
    LEGAL RELATIONSHIP
  </b>
    </p>
    <p>
  <b>9.1 Independent Contractors.</b> The legal relationship between CIRA and
  the Registrant and CIRA and each Registrar of Record is that of independent
  contractors. Under no circumstances shall this Agreement be construed to
  create a partnership, agency or joint venture between CIRA and the Registrant
  or CIRA and any Registrar(s) of Record.
    </p>
    <p>
  <b>9.2 No Agency.</b> Neither party shall have any right, power or authority
  to act on behalf of the other party and neither party shall create any express
  or implied obligations or financial commitments on behalf of the other party.
    </p>
    <p><b>9.3	Registrant Bound as a Principal.</b>  The Registrant agrees
that the Registrant is bound as a principal by all of the terms and conditions
of this Agreement, and the Registry PRP, notwithstanding that the Registrar of
Record and/or an agent of the Registrant applied for the registration of the
Registrant’s selected Domain Name(s) on behalf of the Registrant.  The
continued registration of the Registrant’s Domain Name Registrations
shall ratify any unauthorized actions of the Registrar of Record and any such
agent.  In addition, the Registrant is responsible for any errors made by the
Registrar of Record or any such agent.
    </p><p align="center"><b>ARTICLE 10<br /> 
GENERAL TERMS</b></p>
    <p>
  <b>10.1 Notices.</b> Any notice or other communication provided hereunder
  shall be in writing. Notices from CIRA to the Registrant shall be sent only by
  email to the email addresses listed in the Registration Information for the
  Registrant and/or the Registrant’s Administrative Contact, and will be deemed
  to have been given and received on the date on which they are sent. Notices
  from the Registrant to CIRA shall be sent by: (a) personal delivery, (b)
  courier, or (c) confirmed facsimile transmission, addressed to: General
  Counsel, CIRA 350 Sparks Street, Suite 306, Ottawa, Ontario K1R 7S8 and shall
  be effective on the earlier of: (i) confirmation of receipt or (ii) three days
  after the date of posting or transmission.
    </p>
    <p>
  <b>10.2 Time of Essence.</b> Time is of the essence in this Agreement.
    </p>
    <p>
  <b>10.3 Further Assurances.</b> Each party will promptly do, execute, deliver
  or cause to be done, executed and delivered all further acts, documents and
  things in connection with this Agreement that the other party may reasonably
  require, for the purposes of giving effect to this Agreement.
    </p>
    <p>
  <b>10.4 Successors and Assigns.</b> This Agreement will enure to the benefit
  of, and be binding on, the parties and their respective administrators,
  executors or other legal representatives, successors and permitted and
  qualified assigns. CIRA may assign or transfer all or any part of its rights
  and obligations under this Agreement to any person The Registrant shall not
  assign or transfer, whether absolutely, by way of security or otherwise, all
  or any part of its rights or obligations under this Agreement without the
  prior written consent of CIRA, which consent shall be in CIRA’s sole
  discretion. Any such purported assignment or transfer, or attempt to so assign
  and transfer without CIRA’s prior written consent, shall be of no force and
  effect.
    </p>
    <p>
  <b>10.5 Entire Agreement.</b> This Agreement (including the Registry PRP which
  are incorporated by reference herein) constitutes the entire agreement between
  the parties pertaining to the subject matter of this Agreement and supersedes
  all prior agreements, understandings, negotiations and discussions, whether
  oral or written. There are no conditions, warranties, representations or other
  agreements between the parties in connection with the subject matter of this
  Agreement (whether oral or written, express or implied, statutory or
  otherwise) except as specifically set out in this Agreement.
    </p>
    <p>
  <b>10.6 Waiver.</b> A waiver of any default, breach or non-compliance under
  this Agreement is not effective unless in writing and signed by the party to
  be bound by the waiver. No waiver will be inferred from or implied by any
  failure to act or delay in acting by a party in respect of any default, breach
  or non-observance or by anything done or omitted to be done by the other
  party. The waiver by a party of any default, breach or non-compliance under
  this Agreement will not operate as a waiver of that party’s rights under this
  Agreement in respect of any continuing or subsequent default, breach or
  non-observance (whether of the same or any other nature).
    </p>
    <p>
  <b>10.7 Severability.</b> Any provision of this Agreement which is prohibited
  or unenforceable in any jurisdiction will, as to that jurisdiction, be
  ineffective to the extent of such prohibition or unenforceability and will be
  severed from the balance of this Agreement, all without affecting the
  remaining provisions of this Agreement or affecting the validity or
  enforceability of such provision in any other jurisdiction.
    </p>
    <p>
  <b>10.8 Governing Law; Attornment.</b> This Agreement will be governed by and
  construed in accordance with the laws of the Province of Ontario and the laws
  of Canada applicable in that Province and will be treated, in all respects, as
  an Ontario contract. The Registrant agrees to submit to the personal and
  exclusive jurisdiction of a court of competent jurisdiction in the City of
  Ottawa in the Province of Ontario.
    </p>{' '}
    <p>
  <b>10.9 Force Majeure.</b> Neither party shall be deemed to be in default
  hereunder for any delay or failure to perform its obligations under this
  Agreement resulting from causes beyond its reasonable control. Each party will
  use its best efforts to anticipate such delays and failures, and to devise
  means to eliminate or minimize them.
    </p>
    <p>
  <b>10.10 Remedies Cumulative.</b> The rights and remedies of CIRA under this
  Agreement are cumulative and no exercise or enforcement by CIRA of any right
  or remedy hereunder shall preclude the exercise or enforcement by CIRA of any
  other right or remedy hereunder or to which it is otherwise entitled by law to
  enforce.
    </p>
    <p>
  <b>10.11 Language.</b> The parties to this Agreement have required that this
  Agreement and all deeds, documents and notices relating to this Agreement, be
  drawn up in the English language.{' '}
  <i>
    Les parties aux présentes ont exigé que le présent contrat et tous autres
    contrats, documents ou avis afférents aux présentes soient rédigés en langue
    anglaise.
  </i>
    </p>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      